import { pathOr } from 'ramda';

import { IState } from '../../store';
import { INewbuildingDecoration } from '../../types/newobject/newbuildingDecorations';

export const getNewbuildingDecorations = (state: IState): INewbuildingDecoration[] => {
  return pathOr([], ['offerData', 'newObject', 'decorations'], state);
};
